import { createRouter, createWebHistory, type RouteComponent, type RouteRecordRaw } from "vue-router"
import IncidentLogsPage from "./all-incident-logs"
import VtsLogsPage from "./all-vts-logs"
import CreateIncidentPage from "./create-incident"
import EditIncidentPage from "./edit-incident"
import IncidentMapPage from "./incident-map"
import NotFound from "./NotFound"
import PdfIncidentViewPage from "./pdf-view"
import ProfilePage from "./profile"
import RootRedirectView from "./RootRedirectView"

const simpleRoutes: Record<string, RouteComponent> = {
	"/": RootRedirectView,
	"/incident-map": IncidentMapPage,
	"/incidents/create": CreateIncidentPage,
	"/incidents/id/:incidentLogId": EditIncidentPage,
	"/incidents/pdf/:incidentLogId": PdfIncidentViewPage,
	"/incidents/list": IncidentLogsPage,
	"/vts-logs/list": VtsLogsPage,
	"/profile": ProfilePage,
	"/:pathMatch(.*)*": NotFound,
}
const routes: RouteRecordRaw[] = [
	...Object.entries(simpleRoutes).map(([path, component]) => ({ path, component, name: component.name })),
]

const router = createRouter({
	routes: [...routes],
	history: createWebHistory(),
})

export default router
